/*
 * @Author: Michael 
 * @Date: 2019-03-13 11:15:52 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 11:38:27
 * 获取素材库材料
 */

import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import { AxiosPromiseData } from '@/common/interface';
import store from '@/store';

export default function getSMSData(instIds?: Array<string>) {
  if (instIds) {
    if (instIds.length === 0) return null;
    const param = { instIds };
    // 获取机构短信管理 小麦秀短信验证功能开关
    fetch.Sales('anon/businessShow/batchInstShowVerify', param).then((res: AxiosPromiseData) => {
      const { result } = res;
      const notList: any = []
      if (result) {
        const isVerify = result.every((item: any) => item.lock);
        result.forEach((item: any) => {
          if (!item.lock) {
            notList.push(item.instName)
          }
        })
        store.dispatch('changeInstSMSVerify', isVerify);
        store.dispatch('changeInstNameNot', notList);
        // 获取机构剩余短信条目数
        fetch.Sales('anon/businessShow/getBatchSmsRemainNumber', param).then((res: AxiosPromiseData) => {
          const { result } = res;
          const fewList: any = [];
          const zeroList: any = [];
          let number = Infinity;
          if (result) {
            result.map((item: any) => {
              number = Math.min(item.balance, number);
            })
            result.forEach((item: any) => {
              if (item.balance < 100) {
                fewList.push(item.instName)
                item.balance === 0 && zeroList.push(item.instName)
              }
            })
            store.dispatch('changeInstNameFew', fewList);
            store.dispatch('changeInstNameZero', zeroList);
            store.dispatch('changeSMSRemainNumber', number);
          }
        })
      }
    });
  } else if (!window.location.href.includes('orgId')) {
    const param = { instId: getUrlParam('instId') || store.state.instId };
    // 获取机构短信管理 小麦秀短信验证功能开关
    fetch.Sales('anon/businessShow/instShowVerify', param).then((res: AxiosPromiseData) => {
      const { result } = res;
      if (result) {
        store.dispatch('changeInstSMSVerify', result);
        // 获取机构剩余短信条目数
        fetch.Sales('anon/businessShow/getSmsRemainNumber', param).then((res: AxiosPromiseData) => {
          const { result } = res;
          store.dispatch('changeSMSRemainNumber', result);
        })
      }
    });
  }
}
